import { create } from 'zustand';

export const APS_DATA_EXTRACTION_DISCOVERY_STORAGE_KEY = 'lexo.apsDataExtractionDiscovery.seen';

export function hasSeenApsDiscoveryModal(): boolean {
    try {
        return localStorage.getItem(APS_DATA_EXTRACTION_DISCOVERY_STORAGE_KEY) === '1';
    } catch {
        return true;
    }
}

function markApsDiscoveryModalSeen() {
    try {
        localStorage.setItem(APS_DATA_EXTRACTION_DISCOVERY_STORAGE_KEY, '1');
    } catch {
        // Ignore quota / private-mode failures.
    }
}

function clearApsDiscoveryModalSeen() {
    try {
        localStorage.removeItem(APS_DATA_EXTRACTION_DISCOVERY_STORAGE_KEY);
    } catch {
        // Ignore quota / private-mode failures.
    }
}

interface ApsDiscoveryStore {
    hasSeen: boolean;
    isVideoModalOpen: boolean;
    pendingTryItNow: boolean;
    highlightApsScan: boolean;
    clearSeen(): void;
    showVideoModal(): void;
    replayVideoModal(): void;
    closeVideoModal(): void;
    startTryItNow(): void;
    consumeTryItNow(): void;
    clearApsScanHighlight(): void;
}

const useApsDiscoveryStore = create<ApsDiscoveryStore>((set) => ({
    hasSeen: hasSeenApsDiscoveryModal(),
    isVideoModalOpen: false,
    pendingTryItNow: false,
    highlightApsScan: false,
    clearSeen: () => {
        clearApsDiscoveryModalSeen();
        set({ hasSeen: false });
    },
    showVideoModal: () => set({ isVideoModalOpen: true }),
    replayVideoModal: () => {
        clearApsDiscoveryModalSeen();
        set({ isVideoModalOpen: true, hasSeen: false });
    },
    closeVideoModal: () => {
        markApsDiscoveryModalSeen();
        set({ isVideoModalOpen: false, hasSeen: true });
    },
    startTryItNow: () => {
        markApsDiscoveryModalSeen();
        set({
            isVideoModalOpen: false,
            pendingTryItNow: true,
            highlightApsScan: true,
            hasSeen: true,
        });
    },
    consumeTryItNow: () => set({ pendingTryItNow: false }),
    clearApsScanHighlight: () => set({ highlightApsScan: false }),
}));

export default useApsDiscoveryStore;
